import axios from 'axios'

export default {
    getServiceRequests(page, filter, sorting) {
        var params = {
            page: page,
            serialNumber: filter.serialNumber,
            isHistory: !!filter.isHistory,
            sortBy: sorting.sortBy,
            sortOrder: sorting.sortOrder,

        };
        if (filter.type !== 0) {
            params.status = filter.type
        }
        return axios.get('/api/service-requests',
            {
                params: params
            });
    },
    getServiceRequest(id) {
        return axios.get(`/api/service-requests/${id}`);
    },
    deleteServiceRequest(id) {
        return axios.delete(`/api/service-requests/${id}`);
    },
    saveTicket(dispatch, ticket, number, changeEmail) {
        var fd = new FormData();
        for (let prop in ticket) {
            if (ticket.hasOwnProperty(prop)) {
                if (prop === 'attachments') {
                    for (let i = 0; i < ticket.attachments.length; i++) {
                        if (ticket.attachments[i] instanceof File) {
                            fd.append(`attachments`, ticket.attachments[i]);
                        }
                    }
                } else if (prop === 'complaintCodes') {
                    for (let i = 0; i < ticket.complaintCodes.length; i++) {
                        fd.append(`complaintCodes`, ticket.complaintCodes[i].id);
                    }
                } else {
                    fd.append(prop, ticket[prop]);
                }
            }
        }
        if (changeEmail && changeEmail.useCustom) {
            fd.append('customEmailAddress[serviceCompany]', changeEmail.serviceCompany);
            fd.append('customEmailAddress[phone]', changeEmail.phone);
            fd.append('customEmailAddress[email]', changeEmail.email);
            fd.append('customEmailAddress[custom]', changeEmail.useCustom);
        }

        fd.append('isCreatedFromServiceRequest', true);

        var url = `/api/service-requests/create-service-ticket?number=${number}`

        if (dispatch) {
            url += `&dispatch=${dispatch}`
        }

        return axios.post(url, fd,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    },
    getStatuses() {
        return axios.get('/api/servicetickets/statuses');
    },
    getCategories() {
        return axios.get('/api/dashboard/categories/servicetickets');
    },
    getServiceTicketNumber() {
        return axios.get('/api/servicetickets/getnumber');
    },
    getComplaintCodeCategories() {
        return axios.get(`/api/complaintcodes/categories`);
    },
    getPreviousTickets(id) {
        return axios.get(`/api/servicetickets/${id}/previoustickets`);
    },
    getServiceCompanyCredentials(id) {
        return axios.get(`/api/servicetickets/${id}/getServiceCompanyCredentials`);
    },
    customerIsRs(id) {
        return axios.get(`/api/servicetickets/${id}/customerIsRs`);
    },
    getPreviousTickets(id, pageNumber, previousTicketsPageSize) {
        return axios.get(`/api/servicetickets/${id}/previoustickets`,
            {
                params: {
                    page: pageNumber,
                    perPage: previousTicketsPageSize
                }
            });
    },
    download(filter, sorting) {
        var params = {
            serialNumber: filter.serialNumber,
            isHistory: filter.isHistory == 0 ? false : true,
            dateFrom: filter.dateFrom,
            dateTo: filter.dateTo,
            sortBy: sorting.sortBy,
            sortOrder: sorting.sortOrder,
        };
        return axios.download('/api/service-requests/export', params);
    },
}



// WEBPACK FOOTER //
// ./ClientApp/app/costcoservicerequests/api.js